import PrismicDOM from 'prismic-dom';
import React from 'react';
import styled from 'styled-components';
import replacer from 'utils/replacer';

const linkResolver = doc => {
	if (doc.type === 'post') {
		return '/posts/' + doc.uid;
	}
	return '/' + doc.uid;
};

export default props => {
	const StyledRichText = styled.div``;

	const dom = [];
	if (typeof props.data !== 'undefined') {
		props.data &&
			props.data.map((item, index) => {
				let html;
				switch (item.type) {
					default:
						html = PrismicDOM.RichText.asHtml([item], linkResolver);
						const form = props.form ? props.form.get : null;
						html = replacer(html, form);
						dom.push(<div key={index} dangerouslySetInnerHTML={{ __html: html }} />);
						break;
				}
				return true;
			});
	}
	return <StyledRichText>{dom}</StyledRichText>;
};
